module.exports = __webpack_public_path__ + "static/media/4.8a5109e9.svg";